// libs.
import { Col, Row } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';

// components.
import { Layout } from '@shared';
import { GeoreferencingTitle } from './components/GeoreferencingTitle';
import { GeoreferencingMap } from './components/GeoreferencingMap';
import { LoadingOverlay } from './components/LoadingOverlay';
import { FieldsToCorrect } from './components/FieldsToCorrect';
import { SidebarDocuments } from '../DocumentsAuditDashboard/components/SideBarDocuments/SideBarDocuments';

// hooks.
import { useMedianZonesForMarketMaker } from './hooks';

// selectors.
import {
  getIsLoadingCoordinates,
  getSelectedBusinessLine,
  setDefaultState,
} from './store/slices/georeferencing-slice';

export const Georeferencing = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(getIsLoadingCoordinates);
  const selectedBusinessLine = useSelector(getSelectedBusinessLine);

  const { isLoading: isLoadingMedianZones } = useMedianZonesForMarketMaker();

  const isLoadingAnything = isLoading || isLoadingMedianZones;
  const loadingText = isLoadingMedianZones
    ? 'Cargando zonas medianas...'
    : 'Buscando coordenadas...';

  useEffect(() => {
    return () => {
      dispatch(setDefaultState());
    };
  }, [dispatch]);

  return (
    <Layout>
      <SidebarDocuments />
      <div className="h-100 w-100">
        <GeoreferencingTitle />
        <Row
          className="m-0"
          style={{ height: 'calc(100% - 80px)', width: '100%' }}
        >
          <Col
            className="h-100 p-0"
            style={{ transition: 'width 0.3s ease' }}
            col={selectedBusinessLine ? 9 : 12}
          >
            <GeoreferencingMap />
          </Col>
          {selectedBusinessLine && (
            <Col className="h-100 p-0 col-3">
              <FieldsToCorrect />
            </Col>
          )}
        </Row>
      </div>
      <LoadingOverlay isLoading={isLoadingAnything} loadingText={loadingText} />
    </Layout>
  );
};
